import { CreateSinglePaymentResponse } from "@/models/payment/create-single/createSinglePaymentResponse";

const origin = window.location.origin;
const prefix = import.meta.env.VITE_BASE_HREF;

export const getActiveLoanPaymentSet = {
  hostedPaymentPageUrl: `${origin}${prefix}betaling?tatp=eyJBbW91bnQiOjExMSwiQkZFTnVtYmVyIjoyMjJ9&sum=EZdePfEIUr3Px3wy2rJ0y_jPHIw&paymentid=aea9bc15f0fd4d6aa743b582e17c98bf`,
  alreadyPaid: false,
} as CreateSinglePaymentResponse;
